exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueCarousel-pagination{\n  display: none;\n}\n.metrics-box {\n    width: 94%;\n    margin: 10px 3%;\n    -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);\n            box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);\n    padding: 10px;\n    text-align: center;\n}\n.metrics-box h3{\n    font-size: 14px;\n    color: #000;\n    line-height: 23px;\n}\n.metrics-box h2{\n    font-size: 20px;\n    color: #000;\n    line-height: 23px;\n    min-height: 23px;\n}\n", ""]);

// exports
